import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from '@mui/material';
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import CloseIcon from "@mui/icons-material/Close";

const CustomValueModal = ({ modalOpen, modalType, handleClose, currentValue="", setValue }) => {
    const { t } = useTranslation();

    const [textBoxVal, setTextBoxVal] = React.useState(currentValue);

    const handleApply = () => {
        setValue(textBoxVal);
        handleClose();
    }

    useEffect(() => {
        setTextBoxVal(currentValue);
    }, [currentValue]);

    return (
        <Dialog onClose={handleClose} open={modalOpen} fullWidth maxWidth={"sm"} >
            <div style={{display: 'flex', justifyContent:'space-between'}}>
                <DialogTitle className="dialog-header padding-12">
                    <div className="title margin-left-4">{t('DIAG_TEXT_AREA_TIT')}</div>
                </DialogTitle>
                <IconButton
                  onClick={handleClose}
                  sx={{ borderRadius: "5px" }}>
                  <CloseIcon
                    sx={{
                      height: "28px",
                      width: "28px",
                      color: "#777777",
                    }}
                  />
                </IconButton>
            </div>
            <DialogContent style={{ padding: "0px", fontSize: "12px", fontWeight: "400" }} dividers>
                <div style={styles.rightContainer}>
                    <TextField
                        id="constTextBox"
                        label={modalType}
                        multiline
                        rows={14}
                        value={textBoxVal}
                        onChange={(e) => setTextBoxVal(e.target.value)}
                        sx={{ height: "100%" }}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={handleApply}
                    style={{ ...styles.popupBtn, marginRight: "8px" }}
                >
                    {t("APPLY")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default CustomValueModal;

const styles = {
    popupBtn: {
        minWidth: "32px",
    },
    rightContainer: {
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        padding: "16px",
        minWidth: "150px"
    },
}